// extracted by mini-css-extract-plugin
module.exports =  {"button":"e2ff468f85--button--scbmL","wrapper":"e2ff468f85--wrapper--jxz2l","wrapper--inline":"e2ff468f85--wrapper--inline--o9hjZ","wrapper--big":"e2ff468f85--wrapper--big--fb0Ic"};